import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import Content from '../../components/layout/Content';
import DiscountCodesEditor from './discount-codes/DiscountCodesEditor';
import DiscountCodeDetail from './discount-codes/DiscountCodeDetail';

const DiscountCodesListPage = () => {
    const navigate = useNavigate();

    return (
        <Content>
            <div className='container mx-auto py-10'>
                <div className='flex items-center gap-4 mb-6'>
                    <Button variant='ghost' size='icon' onClick={() => navigate('/cms')}>
                        <ArrowLeft className='h-4 w-4' />
                    </Button>
                    <div>
                        <h1 className='text-3xl font-bold'>Rabattcodes</h1>
                        <p className='text-muted-foreground'>
                            Verwalten Sie Rabattcodes mit Gültigkeitszeiträumen und zugewiesenen Behandlungsvarianten.
                        </p>
                    </div>
                </div>

                <DiscountCodesEditor />
            </div>
        </Content>
    );
};

const DiscountCodesCMS = () => {
    return (
        <Routes>
            <Route path='/' element={<DiscountCodesListPage />} />
            <Route path='/:id' element={<DiscountCodeDetail />} />
        </Routes>
    );
};

export default DiscountCodesCMS;
